import { Button } from "@web/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@web/components/ui/dropdown-menu"
import { useLanguage } from "@web/lib/contexts/language-context"
import { getLanguageInfo } from "@web/lib/i18n"

export function LanguageSwitcher() {
	const { language, setLanguage, availableLanguages } = useLanguage()
	const currentLanguageInfo = getLanguageInfo(language)

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="outline" size="sm" className="gap-2 bg-transparent">
					<img src={currentLanguageInfo.flag} alt={currentLanguageInfo.name} className="h-4 w-4 rounded-full object-cover" />
					{currentLanguageInfo.code.toUpperCase()}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{availableLanguages.map((lang) => (
					<DropdownMenuItem key={lang.code} onClick={() => setLanguage(lang.code)} className="gap-2">
						<img src={lang.flag} alt={lang.name} className="h-4 w-4 rounded-full object-cover" />
						{lang.name}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
